export default function usePacking() {
	const getOrderObj = (sortName, sortOrder) => {
		if (sortName !== "" && sortOrder != "DEFAULT") {
			switch (sortName) {
				case "id":
					return {
						order: {
							id: sortOrder,
						},
					};

				case "createdAt":
					return {
						order: {
							createdAt: sortOrder,
						},
					};
				case "updatedAt":
					return {
						order: {
							updatedAt: sortOrder,
						},
					};
				case "saleOrder.id":
					return {
						order: {
							saleOrderId: sortOrder,
						},
					};
				case "cart.referenceName":
					return {
						order: {
							cart: {
								referenceName: sortOrder,
							},
						},
					};
				case "saleOrder.merchant.referenceName":
					return {
						order: {
							saleOrder: {
								merchant: {
									referenceName: sortOrder,
								},
							},
						},
					};
				case "location.locationCode":
					return {
						order: {
							location: {
								locationCode: {
									name: sortOrder,
								},
							},
						},
					};
				case "serialsLength":
					return {
						order: {
							saleOrderItem: {
								quantity: sortOrder,
							},
						},
					};
				case "status": {
					return {
						order: {
							status: sortOrder,
						},
					};
				}
			}
		} else {
			return {};
		}
	};

	const getFilterObj = (filters, status) => {
		let filterList = [];

		// if (filters?.productId != "all") {
		//     filterList.push({
		//         productId: {
		//             eq: parseInt(filters.productId),
		//         },
		//     });
		// }

		if (filters?.merchantId && filters?.merchantId != "all") {
			filterList.push({
				saleOrder: {
					merchantId: {
						eq: parseInt(filters.merchantId),
					},
				},
			});
		}

		// if (filters?.locationId != "all") {
		//     filterList.push({
		//         locationId: {
		//             eq: parseInt(filters.locationId),
		//         },
		//     });
		// }
		// if (filters?.locationType != "all") {
		//     filterList.push({
		//         location: {
		//             type:
		//             {
		//                 eq: filters.locationType,
		//             }
		//         }
		//     });
		// }

		if (filters?.status && filters?.status != "all") {
			filterList.push({
				status: {
					eq: filters.status,
				},
			});
		}
		return {
			where: {
				and: [...filterList],
			},
		};
	};

	const getSearchObj = (search = "") => {
		let searchRes = {};
		searchRes.query = search;
		return searchRes;
	};
	return {
		getOrderObj,
		getFilterObj,
		getSearchObj,
	};
}
